import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { sendStaffAppMetaData } from '../../eventTriggers'

export function ChildWelfareHistory() {
  const { child_welfare_histories } = useSelector(state=>state)
  const tabDefaultMetaData = useSelector(state=>state.config.tab_default_meta_data.find(tab=> tab.detail == 'child_welfare_history'))
  const dispatch = useDispatch()

  function handleClick(resource) {
    dispatch({
      type: "EDIT_RESOURCE",
      payload: {
        resourceName: "childWelfareHistory",
        resource
      }
    })
    sendStaffAppMetaData(tabDefaultMetaData.modal)
  }

  return (
    <div>
      {
        child_welfare_histories.map(child_welfare=>(
          <div key={child_welfare.id} onClick={()=>handleClick(child_welfare)} className="p-4 border-bottom clickable">
            <b>{child_welfare.title}</b>
            <div>{child_welfare.description}</div>
          </div>
        ))
      }
    </div>
  )
}
